export enum ApplicationSettings {
  accountingPackage = 'AccountingPackage',
  allocateFullRolls = 'AllocateFullRolls',
  autoConfirmOrders = 'AutoConfirmOrders',
  autoLoadEnquiries = 'AutoLoadEnquiries',
  customerKey = 'CustomerKey',
  emailCSVFile = 'EmailCSVFile',
  forecastMinimumStockCalculation = 'ForecastMinimumStockCalculation',
  hideExportHeadings = 'HideExportHeadings',
  invoiceFromPicking = 'InvoiceFromPicking',
  magentoWebsite = 'MagentoWebsite',
  overDeliveryPercentageAllowed = 'OverDeliveryPercentageAllowed',
  printSplitStockLabels = 'PrintSplitStockLabels',
  showPrintOptions = 'ShowPrintOptions',
  allowBlankProductSearch = 'AllowBlankProductSearch',
  allowCustomerPortalInvites = 'AllowCustomerPortalInvites',
  showVatAnalysisOnDocuments = 'ShowVatAnalysisOnDocuments',
}
